<template>
    <!--二手房详情-->
    <div class="second_details">
        <!-- v-wechat-title="title"-->
        <!--<top_nav class="top_nav"></top_nav>-->
        <div class="content">
            <div class="top">
                <div class="title">
                    <span>{{ secondDetailsList.名称 }}</span>
                </div>
                <ul>
                    <li><i class="iconfont">&#xe600;</i><span
                            class="collect"><i>{{ secondDetailsList.收藏次数}}</i>人收藏</span></li>
                    <li>
                        <button @click="openAppoint">预约看房</button>
                        <span class="appointment"><i>{{ secondDetailsList.预约次数}}</i>次预约</span>
                    </li>
                </ul>
            </div>
            <!--图片-->
            <div class="details_wrapper">
                <div class="left">
                    <div class="swiper-container gallery-top">
                        <div class="swiper-wrapper" style="cursor: pointer" ref="videoLs">
                            <!--<div class="swiper-slide" v-show="url !== ''">-->
                            <!--<div class="VR">-->
                            <!--<iframe :src="url" frameborder="0"></iframe>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--<div class="swiper-slide" v-show="secondDetailsList.视频 !== ''">-->
                            <!--<div class="item">-->
                            <!--<video :src="videoUrl" id="video" controls="controls"-->
                            <!--style="width:100%;max-height:400px;">-->
                            <!--</video>-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="swiper-slide" v-for="(item,index) in imagesList" :key="index">
                                <img :src="item" alt="" :onerror="imgerrorfun">
                            </div>
                        </div>
                    </div>
                    <span class="image" @click="lookLarPic()" style="cursor: pointer">点击查看大图</span>
                    <div class="smallImg">
                        <span class="iconfont left-arrow">&#xe609;</span>
                        <div class="swiper-container gallery-thumbs">
                            <ul class="swiper-wrapper" ref="videoLs">
                                <!--<li class="swiper-slide" v-show="url !== ''">-->
                                <!--<iframe :src="url" frameborder="0" id="VRS"></iframe>-->
                                <!--<img :src="secondDetailsList.缩略图" alt="">-->
                                <!--                                    <div class="VRs">-->
                                <!--                                        &lt;!&ndash;<img :src="url" alt="">&ndash;&gt;-->
                                <!--                                        <img :src="secondDetailsList.缩略图" alt="">-->
                                <!--                                    </div>-->
                                <!--</li>-->
                                <!--<li class="swiper-slide" v-show="secondDetailsList.视频 !== ''">-->
                                <!--<div class="items" style="height: 109px">-->
                                <!--<video :src="videoUrl" id="video2"-->
                                <!--style="width:100%;height:109px;">-->
                                <!--</video>-->
                                <!--</div>-->
                                <!--</li>-->
                                <li class="swiper-slide" v-for="(item,index) in imagesList" :key='index'>
                                    <img :src="item" alt="" :onerror="imgerrorfun">
                                </li>
                            </ul>
                        </div>
                        <span class="iconfont right-arrow">&#xe60a;</span>
                    </div>
                    <div class="vr_video">
                        <!--<div class="vr_btn vv_btn" v-if="secondDetailsList.VR链接 !== ''">-->
                        <!--<a :href="secondDetailsList.VR链接" target="_blank">VR</a>-->
                        <!--</div>-->
                        <!--<div class="vv_btn" @click="toShowVideo" v-if="secondDetailsList.视频 !== ''">-->
                        <!--<a :href="secondDetailsList.视频" target="_blank">视频</a>-->
                        <!--</div>-->
                        <div class="vr_btn vv_btn" @click="toShowVR"
                             v-if="secondDetailsList.VR链接 !== null && secondDetailsList.VR链接 !== ''">
                            <!--<a :href="details.url_vr" target="_blank">VR</a>-->
                            <a>VR</a>
                        </div>
                        <div class="vv_btn" @click="toShowVideo"
                             v-if="secondDetailsList.视频 !== null && secondDetailsList.视频 !== ''">
                            <!--<a :href="details.url_video" target="_blank">视频</a>-->
                            <a>视频</a>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="price">
                        <div class="total"><i>{{ secondDetailsList.总价 }}</i>万元</div>
                        <div class="average"><i>{{ secondDetailsList.价格 }}</i>元/平米</div>
                    </div>
                    <ul>
                        <li>
                            <div>小区名称:</div>
                            <span>{{ secondDetailsList.小区 }}</span></li>
                        <li>
                            <div>所在区域:</div>
                            <span>{{ secondDetailsList.区域 }}</span></li>
                        <li>
                            <div>详细地址:</div>
                            <span>{{ secondDetailsList.详细地址 }}</span></li>
                        <li class="detail">
                            <span>{{ secondDetailsList.面积 }}平米</span>
                            <span>{{ secondDetailsList.建房时间 }}年建</span>
                            <span>{{ secondDetailsList.室 }}室{{ secondDetailsList.厅 }}厅{{ secondDetailsList.厨 }}厨{{secondDetailsList.卫 }}卫</span>
                        </li>
                        <li class="detail">
                            <span>{{ secondDetailsList.装修 }}</span>
                            <span>{{ secondDetailsList.楼层层数 }}</span></li>
                    </ul>
                    <div class="hot_line ">
                        <div class="hot_phone">售房热线：{{ phone}}</div>
                        <span>工作时间：{{ gztime }}</span>
                    </div>
                    <div class="btn">
                        <button class="order_table" @click="openAppoint()">预约看房</button>
                        <button class="collect" @click="collectHouses" :class="getClass1">
                            <span class="iconfont">&#xe604;</span>
                            <i class="iconfont">&#xe66c;</i>
                            <div v-show="!selected">收藏房源</div>
                            <div v-show="selected">已收藏</div>
                        </button>
                    </div>
                </div>
            </div>
            <!--二手房源概况-->
            <div class="details">
                <span class="title">房源概况</span>
                <div class="info">
                    <ul class="left">
                        <!--<li>-->
                        <!--<div>户型：</div>-->
                        <!--<span>{{ secondDetailsList.室 }}室{{ secondDetailsList.厅 }}厅{{ secondDetailsList.厨 }}厨{{secondDetailsList.卫 }}卫</span>-->
                        <!--</li>-->
                        <li>
                            <div>面积：</div>
                            <span>{{ secondDetailsList.面积}}平米</span></li>
                        <li>
                            <div>楼层：</div>
                            <span>{{ secondDetailsList.楼层层数}}</span></li>
                        <li>
                            <div>装修：</div>
                            <span>{{ secondDetailsList.装修}}</span></li>
                        <!--<li>-->
                        <!--<div>状态：</div>-->
                        <!--<span>{{ secondDetailsList.交易状态}}</span></li>-->
                        <li>
                            <div>所属区域：</div>
                            <span>{{ secondDetailsList.区域}}</span></li>
                    </ul>
                    <ul class="right">
                        <li>
                            <div>用途：</div>
                            <span>{{ secondDetailsList.用途}}</span></li>
                        <li>
                            <div>产权年限：</div>
                            <span>{{ secondDetailsList.产权年限}}</span></li>
                        <li>
                            <div>有无贷款：</div>
                            <span>{{ secondDetailsList.有无贷款}}</span></li>
                        <li>
                            <div>有无房产证：</div>
                            <span>{{ secondDetailsList.有无房产证}}</span></li>

                        <!--<li>-->
                        <!--<div>委托交易时间：</div>-->
                        <!--<span>{{ secondDetailsList.委托开始时间}} 至 {{ secondDetailsList.委托结束时间}}</span>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--<div>售房原因：</div>-->
                        <!--<span>{{ secondDetailsList.原因}}</span>-->
                        <!--</li>-->
                    </ul>
                </div>
                <span class="title">房源详情介绍</span>
                <div class="textbox" v-html="secondDetailsList.房源介绍"></div>
                <span class="title">交易服务说明</span>
                <div class="textbox" v-html="secondDetailsList.交易服务说明"></div>
                <!--房贷计算机-->
                <div class="calculator title">
                    <span>房贷计算机</span>
                    <calculator v-if="isShows" :propInfo="propSecInfo" class="cal"></calculator>
                </div>
            </div>
            <!--预约看房-->
            <appointment :propHouse="propHouse" v-show="isShow" v-on:headCallBack="headCall"></appointment>
        </div>
        <!--大图弹窗-->
        <div class="largerPic" v-show="isLarger">
            <div class="swiper-container larger-container">
                <div class="swiper-wrapper larger-wrap" ref="videoLs">
                    <!--<div class="swiper-slide" v-show="url !== ''">-->
                    <!--<iframe :src="url" frameborder="0"></iframe>-->
                    <!--</div>-->
                    <!--<div class="swiper-slide" v-show="secondDetailsList.视频 !== ''">-->
                    <!--<div class="lar-item" style="height: 700px">-->
                    <!--<video :src="videoUrl" id="video3" controls="controls"-->
                    <!--style="width:100%;height:700px;">-->
                    <!--</video>-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="swiper-slide" v-for="(item,index) in imagesList" :key='index'>
                        <img :src="item" alt="" :onerror="imgerrorfun">
                    </div>
                </div>
                <div class="swiper-button-next swiper-button-white btn"></div>
                <div class="swiper-button-prev swiper-button-white btn"></div>
                <div class="close" style="cursor: pointer">
                    <i class="iconfont" @click="closeLarger()">&#xe617;</i>
                </div>
            </div>
        </div>
        <div class="ShowVR" v-show="ShowVR">
            <iframe class="VR" id="nb-iframe" :src="VRUrl" frameborder="0"></iframe>
            <div class="exit" @click="closeVR">
                退出
            </div>
        </div>
        <div class="ShowVideo" v-show="ShowVideo">
            <!-- 默认静音 -->
            <!-- <video autoplay muted :src="videoUrl" id="video" controls="controls"></video> -->
            <video autoplay :src="videoUrl" id="video" controls="controls"></video>
            <div class="exit" @click="closeVideo">
                退出
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
	import Swiper from 'swiper';
	import 'swiper/css/swiper.css';
	import Calculator from "../../components/Calculator";
	import Appointment from "../../components/Appointment";
	import {videoPlayer} from 'vue-video-player';
	// import top_nav from '../../components/nav'
	// import PhotoSphereViewer from 'photo-sphere-viewer'
	// import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
	import $ from 'jquery'
	import {getObject, collectHouse} from '../../api/index.js'

	export default {
		data() {
			return {
				toTop: '返回顶部',
				erweima: '',
				upload: false,
				title: '',
				isShow: false,
				selected: false,
				isLarger: false,//看大图
				isShows: false,
				price: [{value: '115'}, {value: '50'}, {value: '3.2'}, {value: '20'}, {value: '70'}],
				secondDetailsList: [],
				imagesList: [],
				// 返回图片为空时默认图片
				imgerrorfun: '',
				// imgerrorfun: 'this.src="' + require('../assets/new-details/img_xfxiangqing_banner.png') + '"',
				propHouse: {
					house_id: '',
				},
				propSecInfo: {},
				gztime: '',
				quyu: [],
				region: '',
				phone: '',
				// playerOptions: {
				// 	height: '400',
				// 	muted: true,//开启声音
				// 	autoplay: false,
				// 	language: 'en',
				// 	playbackRates: [0.7, 1.0, 1.5, 2.0],
				// 	sources: [{
				// 		type: "video/mp4",
				// 		src: "",
				// 	}],
				// 	poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
				// },
				// isEnd: true,//视频播放结束
				ShowVideo: false,
				videoUrl: '',//视频
				ShowVR: false,
				VRUrl: '',
				token: ''

			}
		},
		components: {
			calculator: Calculator,//房贷计算器
			appointment: Appointment,
			// top_nav,
			// "v-footer": Footer,
		},
		computed: {
			getClass1() {
				if (this.selected) {
					return 'active'
				}
			},
		},
		created() {
			this.gztime = localStorage.getItem('gzsj')
			this.phone = localStorage.getItem('sf_phone')
		},
		mounted() {
			this.init();
			console.log(localStorage.getItem('isLogin'))
			if (localStorage.getItem('isLogin') === '1') {
				this.token = localStorage.getItem('token')
				this.isColl()
			}
		},
		methods: {
			// 判断是否收藏
			isColl() {
				this.$api.isCollect({
					object_id: this.$route.params.id,
					token: this.token
				}).then(res => {
					// console.log(res)
					if (res.code === 0) {
						// console.log(res.data.is_collect)
						if (res.data.is_collect === 1) {
							this.selected = true;
						} else {
							this.selected = false;
						}
						// console.log(this.selected)

						// this.$message({
						// 	message: res.msg,
						// 	type: 'success'
						// })
					}

				}).catch(res => {
					// console.log(res)
					this.$message({
						message: res.msg,
						type: 'success'
					})
				})
			},
			// 收藏楼盘
			collectHouses() {
				// 收藏
				// console.log(this.selected)
				if (!this.selected) {
					this.$api.collectHouse({
						object_id: this.$route.params.id,
						token: this.token
					}).then(res => {
						// console.log(res)
						if (res.code === 0) {
							// this.isColl()
							this.selected = true;
							// this.$message({
							// 	message: res.msg,
							// 	type: 'success'
							// })
						}

					}).catch(res => {
						if (res.code === -101) {
							this.$message({
								message: res.msg,
								type: 'success'
							})
							this.$router.push({path: '/login'})
						} else {
							this.$message({
								message: res.msg,
								type: 'success'
							})
						}
					})
				} else {
					// 取消收藏
					this.$api.delCollectHouse({
						object_id: this.$route.params.id,
						token: this.token
					}).then(res => {
						// console.log(res)
						if (res.code === 0) {
							this.selected = false;
							this.$message({
								message: res.msg,
								type: 'success'
							})
						}
					}).catch(res => {
						if (res.code === -101) {
							this.$message({
								message: res.msg,
								type: 'success'
							})
							this.$router.push({path: '/login'})
						} else {
							this.$message({
								message: res.msg,
								type: 'success'
							})
						}
					})
				}
			},
			toShowVR() {
				this.ShowVR = true
				// this.VRUrl = 'https://720yun.com/t/09vkOeq75i7?scene_id=51981427'
				this.VRUrl = this.secondDetailsList.VR链接
			},
			closeVR() {
				this.ShowVR = false
				this.VRUrl = ''
			},
			toShowVideo() {
				this.ShowVideo = true
				this.videoUrl = 'http://' + this.secondDetailsList.视频.split('//')[1]
				// this.videoUrl = this.secondDetailsList.视频
			},
			closeVideo() {
				this.ShowVideo = false
				this.videoUrl = ''
			},
			init() {
				let _this = this
				_this.isShows = false
				_this.detailsId = this.$route.params.id;
				getObject({
					object_id: _this.detailsId
				}).then(res => {
					// console.log(res)
					if (res.code === 0) {
						_this.secondDetailsList = res.data
						// _this.url = res.data.VR链接
						// _this.title = res.data.name + ' 二手房 ' + localStorage.getItem('meta_title')
						_this.imagesList = res.data.轮播图片.split(',')
						_this.propSecInfo.area = res.data.面积
						_this.propSecInfo.total_price = res.data.总价
						_this.propSecInfo.price = res.data.价格
						_this.propSecInfo.huxing = res.data.室 + '室' + res.data.厅 + '厅' + res.data.厨 + '厨' + res.data.卫 + '卫'
						_this.propSecInfo.trpe = 2
						_this.isShows = true
						// if (res.data.is_collect === 1) {
						// 	this.selected = true
						// } else {
						// 	this.selected = false
						// }
						_this.$nextTick(() => {  // 下一个UI帧再初始化swiper
							// _this.showVR()
							// _this.startPlay()
							_this.initSwiper()
							// _this.getVideoImg()
						});
					} else {
						this.$message({
							title: '提示',
							message: res.msg,
							type: 'warning'
						});
					}
					// console.log(_this.secondDetailsList.xiaoqu)
				}).catch(err => {
					// console.log(err)
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			//缩略图
			initSwiper() {
				// let _this = this
				//小图
				// if (_this.secondDetailsList.VR链接 !== '') {
				// 	_this.url = _this.secondDetailsList.VR链接
				// }
				// if (_this.secondDetailsList.视频 !== '') {
				// 	// _this.playerOptions.sources[0].src = _this.secondDetailsList.视频
				// 	_this.videoUrl = _this.secondDetailsList.视频
				// }
				let galleryThumbs = new Swiper('.gallery-thumbs', {
					// direction : 'vertical',//控制滚动的方向，水平或垂直
					spaceBetween: 10,
					slidesPerView: 4,
					freeMode: true,
					loop: true,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
					autoplay: {
						delay: 3500,
						disableOnInteraction: false,
					},
				});
				//大图
				new Swiper('.gallery-top', {
					slidesPerView: 1,
					loop: true,
					navigation: {
						nextEl: '.left-arrow',
						prevEl: '.right-arrow',
					},
					autoplay: {
						delay: 3500,
						disableOnInteraction: false,
					},
					thumbs: {
						swiper: galleryThumbs,
					},
					// on: {
					// 	slideChangeTransitionEnd: function ($event) {
					// 		// console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
					// 		if ($('.swiper-slide-active .VR').length === 1) {
					// 			_this.url = _this.secondDetailsList.VR链接
					// 		} else {
					// 			// galleryThumbs.autoplay.start()
					// 		}
					// 		// $('.swiper-slide .items video')[0].pause()
					// 		if ($('.swiper-slide-active .item').children().hasClass('video-player')) {
					// 			// _this.videoUrl = _this.secondDetailsList.视频
					// 			$('#video')[0].play()
					// 			// _this.playerOptions.sources[0].src = _this.s
					// 			// econdDetailsList.视频
					// 			// $('.swiper-slide-active video')[0].play()
					// 			// if (this.isEnd) {
					// 			// 	// galleryThumbs.autoplay =
					// 			// 	galleryTop.autoplay = 3500
					// 			// 	galleryTop.slideNext()
					// 			// } else {
					// 			// 	// galleryTop.autoplay = false
					// 			// }
					// 		} else {
					// 			$('#video')[0].pause()
					// 			// $('.swiper-slide .item video')[0].pause()
					// 		}
					// 	},
					// }
				});
			},
			//预约看房
			openAppoint() {
				if (!this.isShow) {
					this.isShow = true;
					this.propHouse.house_id = this.detailsId;
				} else {
					this.isShow = false;
				}
			},
			//预约看房关闭后传参
			headCall(res) {
				this.isShow = res
			},
			//轮播图
			largeSwiper() {
				// let _this = this
				let mySwiper = new Swiper('.larger-container', {
					loop: true,
					// spaceBetween: 20,
					slidesPerView: 1,
					// autoplay: {
					// 	disableOnInteraction: false,
					// },
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					// on: {
					// 	slideChangeTransitionEnd: function ($event) {
					// 		console.log($event)
					// 		console.log($('.swiper-slide-active .lar-item').children().hasClass('video-player'))
					// 		if ($('.swiper-slide-active .lar-item').children().hasClass('video-player')) {
					// 			// console.log(_this.playerOptions.sources[0])
					// 			$('#video3')[0].pause()
					// 			// _this.playerOptions.sources[0].src = _this.secondDetailsList.视频
					// 			// $('.swiper-slide-active video')[0].play()
					// 			// if (this.isEnd) {
					// 			// 	$('.swiper-slide video')[0].pause()
					// 			// 	// galleryThumbs.autoplay =
					// 			// 	// galleryTop.autoplay = 3500
					// 			// 	// galleryTop.slideNext()
					// 			// }
					// 		} else {
					// 			$('#video3')[0].pause()
					// 			// $('.swiper-slide video')[0].pause()
					// 		}
					// 	}
					// }
				});
			},
			//关闭大图
			closeLarger() {
				this.isLarger = false
			},
			//打开大图
			lookLarPic() {
				this.isLarger = true
				// $('.swiper-slide .item video')[0].pause()
				this.$nextTick(() => {  // 下一个UI帧再初始化swiper
					this.largeSwiper()
				});
			},
		},
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import 'secondDetail';

    /deep/ iframe {
        z-index: -1;
        .vr-house {
            canvas {
                z-index: 2000 !important;
            }
        }

        .thumbnail {
            .thumbnail-list {
                .list-wrap {
                    ul {
                        li.current {
                            width: 200px !important;
                            height: 114px !important;
                            display: block !important;
                        }
                    }
                }
            }
        }
    }


</style>